// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.bold-uppercase[data-v-526710eb] {\n  font-weight: bold;\n  text-transform: uppercase;\n}\n.warning-text[data-v-526710eb] {\n  font-size: 1.5rem;\n  margin-top: 0px;\n}\n.modalCard[data-v-526710eb] {\n  max-width: 800px;\n  min-height: 250px;\n}\n.main[data-v-526710eb] {\n  background-color: #1e1e1e;\n}\n", ""]);
// Exports
module.exports = exports;
